import React from 'react';
import { Form, Label } from 'semantic-ui-react';

const TextInput = (props) => {
  const { allowonlynumber, input, className, wrapperClassName, disabled, width, type, placeholder, maxLength, min, max, autoComplete, meta: { touched, error } } = props;
  return (
    <Form.Field error={touched && !!error} width={width} className={wrapperClassName}>
      <input {...input}
        className={className}
        placeholder={placeholder}
        type={type}
        disabled={disabled}
        maxLength={maxLength}
        min={min}
        max={max}
        onInput={e => {
          const object = e.target;
          if (object.maxLength > 0) {
            if (object.value.length > object.maxLength) {
              object.value = object.value.slice(0, object.maxLength)
            }
          }
        }}
        autoComplete={autoComplete}
        onKeyPress={evt => {
          const theEvent = evt || window.event;
          let key = theEvent.keyCode || theEvent.which;

          if (key === 13) {
            evt.preventDefault();
          }

          if (allowonlynumber === 'true') {
            key = String.fromCharCode(key);

            var regex = /^\d+$/;
            if (!regex.test(key)) {
              theEvent.returnValue = false;
              if (theEvent.preventDefault) theEvent.preventDefault();
            }
          }
        }}
      />
      {touched && error && <Label basic color='red'>{error}</Label>}
    </Form.Field>
  )
}

export default TextInput;